import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeSwiperCategoriaProjetos = () => {
    document.addEventListener("DOMContentLoaded", function () {
        new Swiper("#swiper-categorias-projetos", {
            slidesPerView: "auto",
            spaceBetween: 16,
            speed: 700,
            navigation: false,
            scrollbar: false
        });
    });
};

export default initializeSwiperCategoriaProjetos;